import { useSignals } from "@preact/signals-react/runtime";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { ArrivalPage } from "../../Components/Arrival/ArrivalPage";
import { DeparturePage } from "../../Components/Departure/DeparturePage";
import { displayMode } from "../../Components/Settings/settingsState";
import { DEFAULT_DISPLAY_MODE, SWITCH_DISPLAY_DELAY } from "../../constants";
import type { DisplayMode } from "../../types/types";

export const Route = createFileRoute("/_timetable/$stationCode")({
	component: RouteComponent,
});

function RouteComponent() {
	useSignals();
	const [mode, setMode] = useState<DisplayMode>(DEFAULT_DISPLAY_MODE);
	const [switchDisplayModeIn, setSwitchDisplayModeIn] = useState(SWITCH_DISPLAY_DELAY);
	const [time, setTime] = useState(new Date());

	useEffect(() => {
		if (displayMode.value !== "both") return;
		const timer = setTimeout(() => {
			const newTime = new Date();
			setTime(newTime);
			if (newTime.getSeconds() !== time.getSeconds()) {
				// On seconds changed
				const newSwitchDisplayModeIn = switchDisplayModeIn - 1;
				setSwitchDisplayModeIn(newSwitchDisplayModeIn);
				if (newSwitchDisplayModeIn <= 0) {
					setMode(mode === "departure" ? "arrival" : "departure");
					setSwitchDisplayModeIn(SWITCH_DISPLAY_DELAY);
				}
			}
		}, 1000);

		return () => clearTimeout(timer);
	}, [time, switchDisplayModeIn, mode]);

	if (displayMode.value === "departure") {
		return <DeparturePage />;
	}
	if (displayMode.value === "arrival") {
		return <ArrivalPage />;
	}

	if (mode === "arrival") {
		return <ArrivalPage />;
	}

	return <DeparturePage />;
}
